export default {
  data () {
    return {
      backupShow: false
    }
  },
  mounted () {
    this._scrollEl = this.getScrollElement()
    if (this._scrollEl) {
      if (this._scrollEl === window) {
        window.scrollTo(0, 0)
      } else {
        this._scrollEl.scrollTop = 0
      }
      this.backupShow = false
      this._scrollEl.addEventListener('scroll', this.handleScrollToTop, { passive: true })
      this.handleScrollToTop()
    }
  },
  beforeDestroy () {
    if (this._scrollEl) {
      this._scrollEl.removeEventListener('scroll', this.handleScrollToTop)
    }
  },
  methods: {
    getScrollElement () {
      if (this.$refs.Box) {
        return this.$refs.Box
      }
      return window
    },
    getScrollTop () {
      if (this._scrollEl === window) {
        return document.documentElement.scrollTop || document.body.scrollTop || 0
      }
      return this._scrollEl.scrollTop
    },
    handleScrollToTop () {
      this.backupShow = this.getScrollTop() > 100
    },
    backToTop () {
      if (this._scrollEl === window) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } else {
        this._scrollEl.scrollTop = 0
      }
      this.backupShow = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/scrollToTop.js